<template>
  <el-tabs v-bind="$attrs" v-on="inputListeners" class="er-tabs">
    <slot></slot>
  </el-tabs>
</template>

<script>
export default {
  inheritAttrs: false,
  data: function() {
    return {};
  },
  computed: {
    inputListeners: function() {
      var vm = this;
      // `Object.assign` merges objects together to form a new object
      return Object.assign(
        {},
        // We add all the listeners from the parent
        this.$listeners,
        // Then we can add custom listeners or override the
        // behavior of some listeners.
        {
          // This ensures that the component works with v-model
          input: function(event) {
            vm.$emit("input", event);
          }
        }
      );
    }
  }
};
</script>

<style lang="scss">
.er-tabs {
  .el-tabs__nav-scroll {
    background: white;
  }
  .el-tabs__nav {
    margin-left: 12px !important;
  }
  .el-tabs__item.is-active {
    color: #0a2463;
    opacity: 1;
    font-weight: 600;
  }
  .el-tabs__active-bar {
    background-color: #0a2463;
  }
  .el-tabs__item:hover {
    color: #0a2463;
    cursor: pointer;
  }
  .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 0px !important;
  }
  .el-tabs__content {
    padding: 12px;
    background: white;
  }
  .el-tabs__item {
    font-size: 13px;
    text-align: center;
    opacity: 0.8;
    color: #0a2463;
  }
}
// @mixin tab-item-font-size {
//   @include responsiveProperty(
//     font-size,
//     $app_font_size_1,
//     $app_font_size_2,
//     $app_font_size_3
//   );
// }
// $height-tablet: 28px;
// $height-medium-screens: 30px;
// $height-wide-screens: 35px;
// @mixin tab-item-height($property) {
//   @include responsiveProperty(
//     $property,
//     $height-tablet,
//     $height-medium-screens,
//     $height-wide-screens
//   );
// }
// .er-tabs {
//   $tab-height: 35px;
//   $active-tab-color: #1966a1;
//   .el-tabs__item {
//     position: relative;
//     background-color: white;
//     @include tab-item-height(height);
//     @include tab-item-height(line-height);
//     @include tab-item-font-size;
//     padding: 0px 0px 0px 20px;
//     span {
//       margin-right: 5px;
//       margin-left: 15px;
//     }
//   }
//   .el-tabs__nav-next,
//   .el-tabs__nav-prev {
//     @include tab-item-height(line-height);
//   }
//   .el-tabs__item.is-active {
//     color: white !important;
//     background-color: $active-tab-color !important;
//   }
//   .el-tabs__item:last-child {
//     padding-right: unset !important;
//   }
//   .el-tabs__item.is-active + .el-tabs__item:before {
//     color: white;
//     background-image: url("../../assets/selectedTab.svg");
//     @include tab-item-height(background-size);
//   }
//   .el-tabs__item.is-active:after {
//     color: white !important;
//     background-image: url("../../assets/selectedTab.svg") !important;
//     @include responsiveProperty(
//       background-size,
//       $height-tablet + 5,
//       $height-medium-screens + 5,
//       $height-wide-screens + 5
//     );
//   }
//   .el-tabs__content {
//     border-top: 5px solid $active-tab-color;
//   }
//   div[id*="tab-"]:after {
//     position: absolute;
//     @include tab-item-height(width);
//     @include responsiveProperty(
//       height,
//       $height-tablet + 5,
//       $height-medium-screens + 5,
//       $height-wide-screens + 5
//     );
//     background-image: url("../../assets/unSelectedTab.svg");
//     content: "";
//     @include tab-item-height(background-size);
//     filter: drop-shadow(2px 0px 1px #7f7f7f);
//     transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
//     float: right;
//     @include responsiveProperty(
//       right,
//       ($height-tablet - 5) * -1,
//       ($height-medium-screens - 5) * -1,
//       ($height-wide-screens - 5) * -1
//     );
//     z-index: 10;
//   }

//   .el-tabs__item:not(.is-disabled):hover {
//     color: #1966a1 !important;
//   }

//   .el-tabs__header .el-tabs__item.is-active {
//     color: white !important;
//     background-color: #fff;
//     border-right-color: #dcdfe6;
//     border-left-color: #dcdfe6;
//   }
// }
</style>
